import { supabase } from "@/lib/supabase";

export interface MeetupMatchScore {
  to_participant_id: string;
  score: number;
  reason: string;
  rank: number | null;
}

/**
 * Returns the participant's outgoing match scores against every other
 * submitted/approved participant in the same event, sorted best-first.
 * Backed by `find_my_meetup_match_scores` (security definer) — gated by
 * participantId, same threat model as the rest of the meetup self-service
 * RPCs.
 */
export async function fetchMyMeetupMatchScores(
  participantId: string,
): Promise<MeetupMatchScore[]> {
  const { data, error } = await supabase.rpc("find_my_meetup_match_scores", {
    p_participant_id: participantId,
  });
  if (error) throw new Error(error.message);
  return (data ?? []) as MeetupMatchScore[];
}
